export const baseFields = {
    date: {
        start_date: {
            label: "Consumption start date",
            errorMsg: "",
            type: "start_date_programs",
            identifier: "start_date",
            default: null,
            required: true,
            tempStartDate: "",
            hasError: false,
        },
        end_date: {
            label: "Consumption end date",
            errorMsg: "",
            type: "end_date_programs",
            identifier: "end_date",
            default: null,
            required: true,
            tempEndDate: "",
            hasError: false,
        },
        pub_date: {
            identifier: "pub_date",
            tempSearchForPubDate: false,
            tempPubStartDate: "",
            tempPubEndDate: "",
            hasError: false,
        },
        showDateModal: false,
    },
    title: {
        label: "Title",
        type: "text",
        identifier: "title",
        default: "",
        showTitleModal: false,
    },
    providers: {
        label: "Channels",
        type: "provider-picker-programs",
        identifier: "provider_keys",
        title: "Channels",
        sites: [],
        channels: [],
        default: [],
        showChannelModal: false,
    },
    genres: {
        label: "Genre",
        type: "genre-picker",
        identifier: "genres",
        config: {
            genres: [],
        },
        default: "",
        showGenreModal: false,
    },
    target_group: {
        label: "Target group",
        identifier: "target_group",
        type: "target_group_programs",
        config: {},
        showTargetGroupModal: false,
    },
    show_all_content_with_traffic_in_period: {
        label: "Show empty results",
        active_text: "Showing empty results",
        inactive_text: "Hiding empty results",
        tooltip_text: "Show all content with viewership during the period (regardless of selected target groups)",
        identifier: "show_all_content_with_traffic_in_period",
        type: "toggle-button",
    },
    start_time_tv: {
        label: "Start time TV",
        identifier: "start_time_tv",
        showAdditionalOptions: false,
        type: "start_time_tv",
        showStartTimeTvModal: false
    },
    countryTarget: {
      label: "Country of production / Main target group",
      identifier: "countryTargetGroups",
      config: {},
      showCountryTargetModal: false
    },
    weekdays: {
        showWeekdayModal: false,
        label: "Week days",
        type: "dropdown-checkboxes-weekdays",
        identifier: "weekdays",
        config: {
          options: [
            {
              value: 1,
              text: "Monday"
            },
            {
              value: 2,
              text: "Tuesday"
            },
            {
              value: 3,
              text: "Wednesday"
            },
            {
              value: 4,
              text: "Thursday"
            },
            {
              value: 5,
              text: "Friday"
            },
            {
              value: 6,
              text: "Saturday"
            },
            {
              value: 7,
              text: "Sunday"
            }
          ]
        },
        default: []
      },
}
